module.exports = __webpack_public_path__ + "static/media/after-market.b87c169f.png";